(()=>{
  function init(){
    const menu=document.getElementById('mobile-nav');
    if(!menu||menu.dataset.puMenuReady)return;
    menu.dataset.puMenuReady='true';
    new MutationObserver(()=>document.querySelectorAll('[data-drawer-open="mobile-nav"]').forEach(button=>button.setAttribute('aria-expanded',String(menu.open)))).observe(menu,{attributes:true,attributeFilter:['open']});
    // Native dialog supplies Escape, focus containment and inert background.
    menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{if(menu.open)menu.close();}));
    window.addEventListener('pagehide',()=>{if(menu.open)menu.close();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
